// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yKPw","input":"styles_input__3jbt1"};